module.exports = __webpack_public_path__ + "static/css_logo-0db0a4630f52c7cbfee6076e85eeadde.png";